export const fadeIn = (selector, { duration, fill } = { duration: 300, fill: 'forwards' }) => {
    const element = document.querySelector(selector);
    
    if (!element) return

    const animation = element.animate([
        { opacity: 0, transform: 'rotate(270deg)' },
        { opacity: 1, transform: 'rotate(0deg)' }
    ], { duration, fill });

    animation.onfinish = () => {
        element.style.display = 'block';
    };
}

export const fadeOut = (selector, { duration, fill } = { duration: 300, fill: 'forwards' }) => {
    const element = document.querySelector(selector);
    
    if (!element) return

    const animation = element.animate([
        { opacity: 1, transform: 'rotate(0deg)' },
        { opacity: 0, transform: 'rotate(90deg)' }
    ], { duration, fill });

    animation.onfinish = () => {
        element.style.display = 'none';
    };
}